// Home.js

import React from 'react';
// 1. All imports MUST be at the very top of the file
import { Link } from 'react-router-dom'; 
import './Home.css'; 
import { useTranslation } from 'react-i18next';
// 2. Variable declarations go AFTER all imports
const logoPath = `${process.env.PUBLIC_URL}/epicurys-icon-00.png`;

function Home() {
    const { t, i18n } = useTranslation();
  return (
    <div className="home-page-container">
        
        {/* SECTION LOGO AND WELCOME */}
        <header className="welcome-header">
            <img 
                src={logoPath} 
                alt="epicurys System Logo" 
                className="site-logo" 
            />
            <h1>{t('home.welcome')}</h1>
            <p className="subtitle">{t('home.subtitle')}</p>
        </header>

        {/* SECTION MAIN ACCESS BUTTONS (Organized and Styled) */}
        <section className="access-buttons-section">
            <h2 className="section-title">{t('home.access_points')}</h2>
            
            <nav className="navigation-links">
                {/* Button 1: Check-In (Action principale) */}
                <Link to="/checkin" className="btn primary-btn">{t('home.guest_checkin')}</Link>
                
                {/* Button 2: Check-Out (Action secondaire) */}
                <Link to="/checkout" className="btn secondary-btn">{t('home.guest_checkout')}</Link>
                
                {/* Button 3: Staff Login (Action spécifique) */}
                <Link to="/login" className="btn staff-btn">{t('home.staff_login')}</Link>
            </nav>
        </section>

        {/* FOOTER SECTION */}
        <footer className="info-footer">
            <p>&copy; {new Date().getFullYear()} Épicurys Systems. All rights reserved.</p>
        </footer>
    </div>
  );
}

export default Home;